import React, { useRef, useEffect } from 'react';
const useOnBodyClickHandler = (ref, shouldComponentCareAboutOutsideClicks, handleComponentExitOperation) => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = (event) => {
        if (shouldComponentCareAboutOutsideClicks && handleComponentExitOperation) {
            if (ref.current && !ref.current.contains(event.target)) {
                handleComponentExitOperation();
            }
        }
    };
    useEffect(() => {
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
};
const OnBodyClickWrapper = ({ children, shouldComponentCareAboutOutsideClicks, handleComponentExitOperation, }) => {
    const wrapperRef = useRef(null);
    useOnBodyClickHandler(wrapperRef, shouldComponentCareAboutOutsideClicks, handleComponentExitOperation);
    return React.createElement("div", { ref: wrapperRef }, children);
};
export { OnBodyClickWrapper };
